import ArrowUp from './ArrowUp'

export default ArrowUp
// eslint-disable-next-line import/export
export * from './ArrowUp'
